module.exports = __webpack_public_path__ + "img/company-templates.5788eb72.svg";